/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Collaborators_Invitecollaboratornofundsfounddescription5Inputs */

const en_settings_collaborators_invitecollaboratornofundsfounddescription5 = /** @type {(inputs: Settings_Collaborators_Invitecollaboratornofundsfounddescription5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No fund with the search result was found`)
};

/**
* | output |
* | --- |
* | "No fund with the search result was found" |
*
* @param {Settings_Collaborators_Invitecollaboratornofundsfounddescription5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_invitecollaboratornofundsfounddescription5 = /** @type {((inputs?: Settings_Collaborators_Invitecollaboratornofundsfounddescription5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Invitecollaboratornofundsfounddescription5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_invitecollaboratornofundsfounddescription5(inputs)
});
export { settings_collaborators_invitecollaboratornofundsfounddescription5 as "settings_collaborators_inviteCollaboratorNoFundsFoundDescription" }